// src/app/services/get-addons/get-addons.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AddonResponseInterface } from '../../interfaces/get-addons.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class GetAddonsService {
  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url+'/cx/get_addons'
  }

  getAddons(token: string, nit: string): Observable<AddonResponseInterface> {
    return this.httpClient.post<AddonResponseInterface>(this.API_URL, { nit }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }
}
